module.exports = __webpack_public_path__ + "static/media/unicorn.67827ad3.png";